import React, { useState } from 'react';

export default function SearchKeyword({
  placeholder = "제목",           // 기본값: "제목"
  searchType = "title",           // 기본값: "title" (title, name, content, author 등)
  onSearch,                       // 검색 실행 콜백 함수
  initialValue = "",              // 초기 검색값
  className = "",                 // 추가 CSS 클래스
  showButton = true,              // 버튼 표시 여부
  buttonText = "검색"             // 버튼 텍스트
}) {
  const [keyword, setKeyword] = useState(initialValue);

  const handleSearch = (e) => {
    e.preventDefault();
    
    if (onSearch) {
      onSearch({
        keyword: keyword.trim(),
        searchType: searchType
      });
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch(e);
    }
  };

  return (
    <div className={`mar-10t ${className}`}>
      <div className="popTable">
        <form id="search" method="get" onSubmit={handleSearch}>
          <tr>
            <td>
              <input 
                type="text" 
                name="keyword" 
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder={placeholder}
              />
              {showButton && (
                <div className="search" onClick={handleSearch}>
                  <button type="submit">{buttonText}</button>
                </div>
              )}
            </td>
          </tr>
        </form>
      </div>
    </div>
  );
}